import * as React from 'react';
import { connect } from 'react-redux';
import { ReportingAccess } from '../../components/pages/survey-admin/ReportingAccess';
import { IApplicationState } from '../../store';
import { ActionCreators as ReportingAccessActionCreators } from '../../store/ReportingAccessStore';
import { SurveyHelper } from '../../utilities';
import { ReportingAccessLoader } from '../loaders/ReportingAccessLoader';

export const AdminReportingAccessContainer: React.ComponentType<{ surveyId: number }> = connect(
	(state: IApplicationState) => ({
		...state.reportingAccess,
		audienceSourceType: SurveyHelper.getAudienceSourceType(state.surveyAdmin.audiences),
		distributionType: SurveyHelper.getDistributionType(state.surveyAdmin.audiences),
		isClosed: SurveyHelper.getSurveyIsClosed(state.surveyAdmin.audiences),
		isLoading: state.surveyAdmin.isLoadingAudiences || state.reportingAccess.isLoadingUsers || state.reportingAccess.isSavingUsers,
		surveyAdminSummary: state.surveyAdmin.surveyAdminSummary,
		userType: state.oidc.user?.profile.userType,
		validationResults: state.reportingAccess.reportingUsersValidationModel?.validationResults,
	}),
	{ ...ReportingAccessActionCreators },
)(ReportingAccess);

export const ReportingLoaderContainer = connect(
	(state: IApplicationState) => ({
		...state.reportingAccess,
	}),
	{ ...ReportingAccessActionCreators },
)(ReportingAccessLoader);

export class AdminReportingAccessPage extends React.PureComponent<{ surveyId: number }> {
	public render() {
		return (
			<>
				<ReportingLoaderContainer {...this.props} />
				<AdminReportingAccessContainer surveyId={this.props.surveyId} />
			</>
		);
	}
}
